module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@3x-f10eb6da362327de8465f2a92ba0f4a9.png";